module.exports = __webpack_public_path__ + "dashboard/img/siren-on.6003b84ba3dd64b444e267d66f705539.svg";